import { auth } from "../firebase";
import ENV from "../env";

const recordExternalSales = async ({ eventId, orgId, requestId, rows }) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Authentication required");

  const response = await fetch(`${ENV.firebaseApiUrl}/ticketing/record-external-sales`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ eventId, orgId, requestId, rows }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || "Could not record external ticket sales");
  }
  return data;
};

export default recordExternalSales;
